export const DOWNLOAD_STORAGE_KEY = 'downloadModalId';
export const BUTTON_CONTAINER_HEIGHT = 68;
